// Globals
import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { API, graphqlOperation } from 'aws-amplify';

// UI
import { Button, Form } from 'antd';

// Locals
import AccountUploadPhoto from './AccountUploadPhoto';
import styles from './Account.module.css';
import CardFormInput from '../CardForms/CardFormInput';
import { updateUser as updateUserAction } from '../../actions';
import useUser from '../../hooks/useUser';
import { UpdateUserProfileMutation } from '../../graphql/api';
import { updateUserProfile } from '../../graphql/mutations';

// Types

const AccountProfile: React.FC = () => {
  const [profileForm] = Form.useForm();
  const { user } = useUser();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);

  const submitUpdateUser = useCallback(async () => {
    try {
      await profileForm.validateFields();
    } catch {
      return;
    }

    setLoading(true);
    const formValues = profileForm.getFieldsValue();

    const result = await (API.graphql(
      graphqlOperation(updateUserProfile, {
        input: {
          title: formValues.title,
          fullName: formValues.fullName,
        },
      })
    ) as Promise<{ data: UpdateUserProfileMutation }>);
    setLoading(false);

    if (result) {
      dispatch(
        updateUserAction({
          title: result.data.updateUserProfile?.title || '',
          fullName: result.data.updateUserProfile?.fullName || '',
          email: result.data.updateUserProfile?.email || '',
        })
      );
    }
  }, [dispatch, profileForm]);

  //const validateUrl = (url?: string): string | undefined => {
  //  if (url) {
  //    const matched = url.match(/^(https?:\/\/)?(.+)$/);
  //    const prefix = matched ? (matched[1] ? matched[1] : 'https://') : '';
  //    const newUrl = matched ? matched[2] : url;
  //    return prefix + newUrl;
  //  }
  //  return '';
  //};

  return !user ? null : (
    <div className={styles.profile}>
      <Form
        layout="vertical"
        hideRequiredMark
        autoComplete="off"
        form={profileForm}
        initialValues={{ fullName: user.fullName, title: user.title }}
      >
        <AccountUploadPhoto />
        <div className={styles.profileInputsWrapper}>
          <div>
            <CardFormInput
              name="fullName"
              fieldLabel="Full name"
              maxLength={60}
            />
          </div>
          <div>
            <CardFormInput
              name="title"
              fieldLabel="Job title and company (optional)"
              maxLength={60}
              required={false}
            />
          </div>
          <div className={styles.saveProfile}>
            <Button
              type={'primary'}
              onClick={() => submitUpdateUser()}
              loading={loading}
              disabled={loading}
            >
              Save
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default AccountProfile;
